
namespace GeniuzPOS.CustomReport {

    @Serenity.Decorators.registerClass()
    export class ReportCustomerSurveyDialog extends Serenity.EntityDialog<ReportCustomerSurveyRow, any> {
        protected getFormKey() { return ReportCustomerSurveyForm.formKey; }
        protected getIdProperty() { return ReportCustomerSurveyRow.idProperty; }
        protected getLocalTextPrefix() { return ReportCustomerSurveyRow.localTextPrefix; }
        protected getNameProperty() { return ReportCustomerSurveyRow.nameProperty; }
        protected getService() { return ReportCustomerSurveyService.baseUrl; }
        protected getDeletePermission() { return ReportCustomerSurveyRow.deletePermission; }
        protected getInsertPermission() { return ReportCustomerSurveyRow.insertPermission; }
        protected getUpdatePermission() { return ReportCustomerSurveyRow.updatePermission; }

        protected form = new ReportCustomerSurveyForm(this.idPrefix);

        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
               buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            return buttons;


        }


    }
}